<template>
	<section class="category-add">
		<table class="category-add__table">
			<tbody>
				<tr class="category-add__table__tr">
					<th class="category-add__table__th" colspan="2">
						카테고리명
					</th>
					<td class="category-add__table__td" colspan="2">
						<label>
							<input
								v-model="name"
								type="text"
								placeholder="카테고리명"
							/>
						</label>
					</td>
				</tr>
				<tr class="category-add__table__tr">
					<th class="category-add__table__th">노출여부</th>
					<td class="category-add__table__td">
						<toggleswitch-box
							@click.native="toggleIsShow"
							:checkSts="isDisplay"
							:checkObj="{ value: true, text: '노출' }"
							:unCheckObj="{ value: false, text: '미노출' }"
						/>
					</td>
					<th class="category-add__table__th">New 표시</th>
					<td class="category-add__table__td">
						<toggleswitch-box
							@click.native="toggleIsNew"
							:checkSts="isNew"
							:checkObj="{ value: true, text: '표시' }"
							:unCheckObj="{ value: false, text: '비표시' }"
						/>
					</td>
				</tr>
				<tr
					v-show="currentSelected.depth === 'category1st'"
					class="category-add__table__tr"
				>
					<th class="category-add__table__th" colspan="2">이미지</th>
					<td class="category-add__table__td" colspan="2">
						<img :src="image" alt="" />
						<input
							type="file"
							@change="uploadImage($event, 'iconUpload')"
							ref="categoryImage"
							class="category-add__table__upload-image-button"
						/>
					</td>
				</tr>
				<tr
					v-show="currentSelected.depth === 'category1st'"
					class="category-add__table__tr"
				>
					<th class="category-add__table__th" colspan="2">
						랭킹모둘 배경이미지
					</th>
					<td class="category-add__table__td" colspan="2">
						<img :src="rankingImage" alt="" />
						<input
							type="file"
							@change="uploadImage($event, 'backUpload')"
							ref="rankingImage"
							class="category-add__table__upload-image-button"
						/>
					</td>
				</tr>
			</tbody>
		</table>
	</section>
</template>
<script>
	import ToggleswitchBox from '../../../components/ToggleswitchBox.vue';
	import { getImagePath } from '@/util';

	export default {
		name: 'CategoryAdding',
		components: {
			ToggleswitchBox,
		},
		data() {
			return {
				name: '',
				isDisplay: false,
				isNew: false,
				image: null,
				fileExt: null,
				fileName: null,
				rankingImage: null,
				rankingImageExt: null,
				rankingImageName: null,
			};
		},
		computed: {
			currentSelected() {
				return this.$store.state.category.selection.adding;
			},
		},
		methods: {
			async add() {
				if (this.name.trim().length === 0) {
					alert('카테고리명을 입력해주세요.');
					this.$store.commit('toggleSpinner', false);
					return false;
				} else if (this.currentSelected.level === 1 && this.isDisplay) {
					this.$store.commit('toggleSpinner', false);
					alert(
						'1차 카테고리 신규 등록시 노출상태로 등록할 수 없습니다.'
					);
					this.$store.commit('toggleSpinner', false);
					this.isDisplay = false;
					return false;
				} else if (
					this.$store.getters['category/isCategoryNameDuplicate'](
						this.name,
						this.currentSelected.depth
					)
				) {
					alert('이미 등록된 카테고리명입니다.');
					this.$store.commit('toggleSpinner', false);
					return false;
				} else if (
					!this.image &&
					this.currentSelected.depth === 'category1st'
				) {
					alert(' 이미지를 등록해주세요.');
					this.$store.commit('toggleSpinner', false);
					return false;
				}

				const data = {};
				const level = this.currentSelected.level;

				data.categoryText = this.name;
				data.categoryShortText = this.name;
				data.idCategory = null;
				data.isDisplay = this.isDisplay;
				data.isNew = this.isNew;

				if (
					this.$store.state.category[this.currentSelected.depth]
						.length > 0
				) {
					data.sortKey =
						this.$store.state.category[
							this.currentSelected.depth
						].pop().sortKey + 1;
				} else {
					data.sortKey = 0;
				}

				data.idParentCategory = this.currentSelected.parentId;

				if (!!this.image) {
					const response = await this.$axiosAdmin2.post(
						'/api/common/image',
						{
							data: this.image,
							extension: this.fileExt,
							fileName: this.fileName,
							target: 'category',
						}
					);

					data.fileDir = response.data.data.fileDir;
					data.fileSaveName = response.data.data.fileSaveName;
				} else {
					data.fileDir = null;
					data.fileSaveName = null;
				}

				if (!!this.rankingImage) {
					const response = await this.$axiosAdmin2.post(
						'/api/common/image',
						{
							data: this.rankingImage,
							extension: this.rankingImageExt,
							fileName: this.rankingImageName,
							target: 'category',
						}
					);
					const file = response.data.data;
					data.bgImageUrl = getImagePath(
						file.fileDir,
						file.fileSaveName
					);
				} else {
					data.bgImageUrl = null;
				}

				this.$axiosAdmin2
					.post(`/api/categories/level/${level}`, data)
					.then(({ data }) => {
						alert('새로운 카테고리가 생성되었습니다.');

						if (this.currentSelected.depth === 'category1st') {
							this.categoryMainReload();
						} else {
							this.categorySubReload();
						}
					})
					.catch(error => {
						console.error(error);

						if (err.response && err.response.status === 500) {
							alert(err.response.data.message);
						} else {
							alert(
								'저장에 실패하였습니다. 지속적인 문제 발생시 개발팀에 문의바랍니다. '
							);
						}
					});
			},
			close() {
				this.$store.commit('modal/toggleModal', false);
				this.$store.commit('toggleSpinner', false);
			},
			toggleIsShow() {
				this.isDisplay = !this.isDisplay;
			},
			toggleIsNew() {
				this.isNew = !this.isNew;
			},
			uploadImage($event, name) {
				const image = $event.target.files[0];
				const reader = new FileReader();
				reader.readAsDataURL(image);

				if (name === 'iconUpload') {
					if (image.size > 1024 * 1024) {
						this.$refs.categoryImage.value = null;
						alert('이미지는 1메가까지 등록이 가능합니다.');
						return false;
					}

					this.fileExt = image.type.split('/').pop();
					this.fileName = image.name;

					reader.onload = event => {
						this.image = event.target.result;
					};
				} else {
					this.rankingImageExt = image.type.split('/').pop();
					this.rankingImageName = image.name;
					reader.onload = event => {
						const file = new Image();
						this.rankingImage = event.target.result;
						file.src = this.rankingImage;

						file.onload = () => {
							const width = file.width;
							const height = file.height;
							const ratio = width / height;
							if (ratio !== 1) {
								alert('사이즈 비율이 1:1만 업로드 가능합니다.');
								this.$refs.rankingImage.value = null;
								this.rankingImage = null;
								return false;
							}
						};
					};
				}
			},
			categoryMainReload() {
				this.$axiosAdmin2
					.get(`/api/categories/level/1`)
					.then(({ data }) => {
						const categories = data.data;

						_.each(categories, category => {
							category.id = category.idFirstCategory;
							category.name = category.firstCategoryText;
						});

						this.$store.commit('category/setCategory', {
							selection: 'category1st',
							data: categories,
						});

						this.$store.commit('toggleSpinner', false);
						this.close();
					});
			},
			categorySubReload() {
				this.$axiosAdmin2
					.get(
						`/api/categories/level/${this.currentSelected.level}?idParentCategory=${this.currentSelected.parentId}`
					)
					.then(({ data }) => {
						const categories = data.data;
						const changeSelection = {};
						let parentDepth;

						if (this.currentSelected.level === 2) {
							parentDepth = 'category1st';

							_.each(categories, category => {
								category.id = category.idSecondCategory;
								category.name = category.secondCategoryText;
								category.shortText =
									category.secondCategoryShortText;
							});
						} else if (this.currentSelected.level === 3) {
							parentDepth = 'category2nd';

							_.each(categories, category => {
								category.id = category.idThirdCategory;
								category.name = category.thirdCategoryText;
								category.shortText =
									category.thirdCategoryShortText;
							});
						}

						changeSelection.id = this.currentSelected.parentId;
						changeSelection.subCategories = categories;
						changeSelection.depth = parentDepth;

						this.$store.commit(
							'category/changeSelection',
							changeSelection
						);

						this.$store.commit('toggleSpinner', false);

						this.close();
					});
			},
		},
	};
</script>
<style lang="scss" scoped>
	body {
		.category-add {
			background-color: #fff;
		}

		.category-add__table {
			border-collapse: collapse;
			table-layout: fixed;
		}

		.category-add__table__th {
			vertical-align: middle;
			padding: 1em 0 1em 1em;
			font-weight: bold;
			background: #f4f7fa;
			color: #657088;
			border: 1px solid #dfe6ee;
		}

		.category-add__table__td {
			vertical-align: middle;
			padding: 1em;
			border: 1px solid #dfe6ee;
			text-align: center;
		}

		.category-add__table__upload-image-button {
			margin: auto;
		}
	}
</style>
